import { Suspense, type FunctionComponent } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import {
  openGASpotlightTour,
  useIsGAOnboardingOpen,
} from '../betaGASharedState';

export const LazyGAOnboardingModal: FunctionComponent = () => {
  const shouldShowOnboarding = useIsGAOnboardingOpen();

  const PPOnboardingModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "personal-productivity-onboarding-modal" */ './PPOnboardingModal'
      ),
    {
      namedImport: 'PPOnboardingModal',
      preload: shouldShowOnboarding,
    },
  );

  if (!shouldShowOnboarding) {
    return null;
  }

  return (
    shouldShowOnboarding && (
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <PPOnboardingModal onComplete={openGASpotlightTour} />
        </ChunkLoadErrorBoundary>
      </Suspense>
    )
  );
};
